var SetFilterDisplayValue = /** @class */ (function () {
    function SetFilterDisplayValue() {
    }
    SetFilterDisplayValue.SELECT_ALL = '__AG_SELECT_ALL__';
    return SetFilterDisplayValue;
}());
export { SetFilterDisplayValue };
